import { Injectable } from '@angular/core';
import { collection, Firestore, getDocs } from '@angular/fire/firestore';
import { IPaymentMethod, IPaymentMethodItem } from '../models/payment.interface';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {

  currentPaymentItemUid = '';

  currentPaymentMethod!: IPaymentMethod;

  constructor(private firestore: Firestore) {
    this.clearCurrentPaymentMethod();
  }

  clearCurrentPaymentMethod() {
    this.currentPaymentMethod = {
      active: false,
      type: '',
      name: '',
      number: '',
      number_masked: '',
      expiration_month: '',
      expiration_year: '',
      cvv: '',
    }
    this.currentPaymentItemUid = '';
  }

  async list(userRegistrationId: string) {
    try {
      const paymentMethodsRead = await getDocs(collection(this.firestore, `userProfile/${userRegistrationId}/paymentMethods`))
      let paymentMethods = new Array<IPaymentMethodItem>();
      paymentMethodsRead.forEach(paymentMethodDoc => {
        if (paymentMethodDoc.exists()) {
          paymentMethods.push({
            uid: paymentMethodDoc.id,
            active: paymentMethodDoc.get('active'),
            name: paymentMethodDoc.get('name'),
            number: paymentMethodDoc.get('number_masked'),
          });
        }
      });
      return paymentMethods;
    } catch (e) {
      console.log("Error reading payment methods: PM01. " + e)
      return [];
    }
  }

}
